import React from "react";

/**
 * Simpele locatie-kaart voor content-pagina's — Google Maps embed-iframe.
 *
 * Waarom Google Maps embed en geen Leaflet/OSM?
 *  - De vorige Leaflet-implementatie werkte niet betrouwbaar in productie
 *    (tegels laadden niet, resulteerde in een leeg groen vlak).
 *  - De publieke Google Maps embed heeft geen API-key nodig, werkt overal
 *    en is meteen interactief (zoomen, slepen, "In Maps openen").
 *
 * Props (backward-compatible met de oude Leaflet-versie):
 *  - lat, lng   → coördinaten waar de kaart op centreert
 *  - name       → optioneel: gebruik in plaats van coördinaten als zoekterm
 *                 (bv. `name="Lemmer centrum"` voor een breder gebied dan één punt)
 *  - address    → optioneel, wordt aan de zoekterm toegevoegd
 *  - zoom       → default 15
 *  - height     → desktop hoogte in px (default 400); mobiel schaalt via clamp
 */
export const LocationMap = ({
  lat,
  lng,
  name,
  address,
  zoom = 15,
  height = 400,
  useNameAsQuery = false,
}) => {
  // Zoekterm bepalen: standaard exacte coördinaten, tenzij expliciet naam-gebaseerd.
  const query = useNameAsQuery && name
    ? encodeURIComponent(`${name}${address ? " " + address : ""}`)
    : `${lat},${lng}`;
  const src = `https://maps.google.com/maps?q=${query}&z=${zoom}&hl=nl&output=embed`;
  const title = `Kaart van ${name || "Lemmer centrum"}`;

  // Responsive hoogte: op mobiel niet te dominant, op desktop volle hoogte.
  const responsiveHeight = `clamp(260px, 42vw, ${height}px)`;

  return (
    <div
      data-testid="location-map"
      className="relative rounded-2xl overflow-hidden border border-[#E4EEF5] shadow-sm bg-[#F4F8FB]"
      style={{ height: responsiveHeight }}
    >
      <iframe
        title={title}
        src={src}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
        style={{
          border: 0,
          width: "100%",
          height: "100%",
          display: "block",
        }}
      />
    </div>
  );
};

export default LocationMap;
